import {PageTitle, mergeSxs, BackToLink} from '@hconnect/uikit/src/lib2'
import {Box, Stack} from '@mui/material'
import {memo, ReactNode} from 'react'

type StatusPageHeaderProps = {
  title?: string
  backButtonProps?: {
    targetName: string
    target: string
  }
  onGoBackClick: (route: string) => void
  filterComponent?: ReactNode
  actionButtons?: ReactNode
}

export const PageHeader = memo<StatusPageHeaderProps>(
  ({title, filterComponent, backButtonProps, actionButtons, onGoBackClick}) => {
    return (
      <>
        <Stack
          direction={{xs: 'column', sm: 'row'}}
          justifyContent={'space-between'}
          flexWrap="wrap"
          mb={3}
          gap={1}
          sx={mergeSxs((theme) => ({
            justifyContent: 'flex-end',
            [theme.breakpoints.down('sm')]: {
              mb: theme.spacing(2)
            }
          }))}
        >
          <Box display="flex" flexDirection="column" justifyContent="space-between" mr="auto">
            {backButtonProps && (
              <BackToLink
                navigate={onGoBackClick}
                targetName={backButtonProps.targetName}
                target={backButtonProps.target}
              />
            )}
            <PageTitle
              mx={3}
              mb={!backButtonProps ? 2 : 0}
              sx={{display: 'inline-flex', alignItems: 'center'}}
              data-test-id="page-title"
            >
              {title}
            </PageTitle>
          </Box>
          {(filterComponent || actionButtons) && (
            <Box
              display="flex"
              flexDirection={{xs: 'column', sm: 'row'}}
              justifyContent="space-between"
              gap={1}
              m={{xs: 2, sm: 0}}
            >
              {filterComponent}
              {actionButtons}
            </Box>
          )}
        </Stack>
      </>
    )
  }
)
